import { gql } from '@apollo/client'

export interface MarketplaceItemLiquidityVars {
  chainId: number
  marketplaceItemId: string
}

interface OrderBook {
  fractionsLocked: string
  averagePrice: string
  totalCost: string
}

interface MarketplaceItemLiquidity {
  orderBook: OrderBook | null
}

export interface MarketplaceItemLiquidityData {
  marketplaceItemLiquidity: MarketplaceItemLiquidity
}

export const MARKETPLACE_ITEM_LIQUIDITY_QUERY = gql`
  query MarketplaceItemLiquidity($chainId: Int!, $marketplaceItemId: String!) {
    marketplaceItemLiquidity(chainId: $chainId, marketplaceItemAddress: $marketplaceItemId) {
      orderBook {
        fractionsLocked
        averagePrice
        totalCost
      }
    }
  }
`
